import AbstractValue from '@/models/app-config/behavior/abstract-value'

export interface RawAddToCartButton {
  enabled: boolean
}

export class AddToCartButton extends AbstractValue<RawAddToCartButton> {
  get enabled(): boolean {
    return this.raw.enabled
  }
}
